import { useMutation } from "react-query";

import { makeRequest } from "../../util";

export default function useOptIntoEventLibrary(
  onSuccess: () => void,
  onError: () => void
) {
  return useMutation(
    () => {
      return makeRequest("opt_into_event_library");
    },
    {
      onSuccess,
      onError,
    }
  );
}
